export default __webpack_public_path__ + "static/media/image_insp.2741241d.svg";